import { Link } from "react-router-dom";

const footerColumns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "电影", to: "/category/movie" },
      { label: "电视剧", to: "/category/series" },
      { label: "影评专题", to: "/review/topic/t1" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
      { label: "搜索影视", to: "/search" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 py-14 md:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <Link to="/" className="flex cursor-pointer items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-film-line text-xl" />
            </span>
            <span className="font-heading text-xl font-black tracking-wide text-background-50">疯狂的欲望</span>
          </Link>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            专注最新电影与电视剧的资讯、剧情介绍、演员阵容与影评分析，为影视爱好者提供权威的影视动态与深入的观影参考。
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[
              { icon: "ri-wechat-line", label: "微信" },
              { icon: "ri-weibo-line", label: "微博" },
              { icon: "ri-bilibili-line", label: "哔哩哔哩" },
              { icon: "ri-movie-2-line", label: "豆瓣" },
            ].map((s) => (
              <a
                key={s.label}
                href="#social"
                aria-label={s.label}
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-primary-900 text-background-200 transition-colors hover:bg-accent-500 hover:text-primary-950"
              >
                <i className={`${s.icon} text-lg`} />
              </a>
            ))}
          </div>
        </div>

        {footerColumns.map((col) => (
          <div key={col.title}>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-accent-400">
              <a href="#footer-nav">{col.title}</a>
            </h4>
            <ul id="footer-nav" className="mt-4 space-y-2.5">
              {col.links.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="cursor-pointer text-sm text-background-300 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto flex flex-col gap-3 px-4 py-6 text-xs text-background-400 md:flex-row md:items-center md:justify-between md:px-8">
          <p>© 2026 疯狂的欲望 影视资讯站 · 本站内容与数据均为虚构示例，仅用于演示</p>
          <p className="flex items-center gap-4">
            <a href="#disclaimer" className="cursor-pointer transition-colors hover:text-background-100">
              免责声明
            </a>
            <a href="#contact" className="cursor-pointer transition-colors hover:text-background-100">
              联系邮箱 hello@kuangwang-movie.demo
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}